/** React `key` for a control: `name`, or `label` if name is missing. */
export const getStableControlKey = (control: {
  key?: string;
  label?: string;
}): string => {
  return String(control?.key ?? control?.label ?? '');
};
